export function head(array) {
    if (array.length === 0)
        return undefined;
    const [head] = array;
    return head;
}
export function last(array) {
    return array.slice(-1)[0];
}
export function uniq(array) {
    return [...new Set(array)];
}
export function flatten(array) {
    // @ts-ignore
    return array.reduce((a, b) => a.concat(b), []);
}
export function isEmpty(obj) {
    return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
}
export const sortByFunc = (f) => {
    return (a, b) => (f(a) > f(b) ? 1 : f(b) > f(a) ? -1 : 0);
};
export function toNumber(value) {
    if (typeof value === 'number') {
        return value;
    }
    return Number(value);
}
export function ensureString(value) {
    // toString
    if (typeof value === 'number') {
        return value.toString();
    }
    if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
    }
    return value;
}
export function round(x, n) {
    return Math.round(x * Math.pow(10, n)) / Math.pow(10, n);
}
export function throttle(func, wait = 100) {
    let timer = null;
    return function (...args) {
        if (timer === null) {
            timer = setTimeout(() => {
                func.apply(this, args);
                timer = null;
            }, wait);
        }
    };
}
export function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        }, wait);
        if (immediate && !timeout)
            func.apply(context, args);
    };
}
export function uniqBy(arr, key) {
    const seen = new Set();
    return arr.filter((it) => {
        const val = it[key];
        if (seen.has(val)) {
            return false;
        }
        seen.add(val);
        return true;
    });
}
